import { useCallback } from 'react';
import UseContext from 'hooks/useContext';

/** The slide-over of the invoice detail (JBWEB-1274). */
export const INVOICE_DETAIL_SLIDE_OVER = 'get_invoice';

/**
 * Opens the detail of an invoice by its BeSTT number: the eye of the month
 * list, and later the journal (JBWEB-1280) and the company's invoices
 * (JBWEB-1308). The number goes in `objID` as a Number: the routes take it as
 * the invoice's identifier.
 */
const useOpenInvoiceDetail = () => {
  const { setObjID, setSlideOverType, setSlideOverShow } = UseContext();
  return useCallback(
    (number) => {
      setObjID(Number(number));
      setSlideOverType(INVOICE_DETAIL_SLIDE_OVER);
      setSlideOverShow(true);
    },
    [setObjID, setSlideOverType, setSlideOverShow],
  );
};

export default useOpenInvoiceDetail;
